import * as React from "react";
import { JSX } from "react/jsx-runtime";
const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={14.8152} cy={14.8152} r={14.8152} fill="#4682B4" />
    <path
      d="M7.15234 14.5762C6.73813 14.5762 6.40234 14.912 6.40234 15.3262C6.40234 15.7404 6.73813 16.0762 7.15234 16.0762V15.3262V14.5762ZM23.0088 15.8565C23.3017 15.5636 23.3017 15.0887 23.0088 14.7958L18.2358 10.0229C17.9429 9.72998 17.468 9.72998 17.1751 10.0229C16.8822 10.3158 16.8822 10.7906 17.1751 11.0835L21.4178 15.3262L17.1751 19.5688C16.8822 19.8617 16.8822 20.3366 17.1751 20.6295C17.468 20.9224 17.9429 20.9224 18.2358 20.6295L23.0088 15.8565ZM7.15234 15.3262V16.0762L22.4784 16.0762V15.3262V14.5762L7.15234 14.5762V15.3262Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
